export interface ForeignRegionArgs {
  id: number;
  name: string;
  grades: Array<{ id?: number; foreign_hotel_price_limit: number | '' }>;
  countries: Array<{
    id: number;
    name: string;
    grades: Array<{ id?: number; foreign_hotel_price_limit: number | '' }>;
    hidden: boolean;
  }>;
  hidden: boolean;
}

class ForeignRegion {
  public id: number;
  public name: string;
  public grades: { id: number | null; foreignHotelPriceLimit: number | '' }[];
  public countries: {
    id: number;
    name: string;
    grades: { id: number | null; foreignHotelPriceLimit: number | '' }[];
    hidden: boolean;
  }[];

  public hidden: boolean;

  constructor(args: ForeignRegionArgs) {
    this.id = args.id;
    this.name = args.name;
    this.grades = args.grades.map(g => ({
      id: g.id || null,
      foreignHotelPriceLimit: g.foreign_hotel_price_limit
    }));
    this.countries = args.countries.map(c => ({
      id: c.id,
      name: c.name,
      grades: c.grades.map(g => ({
        id: g.id || null,
        foreignHotelPriceLimit: g.foreign_hotel_price_limit
      })),
      hidden: true
    }));
    this.hidden = true;
  }

  submitParams() {
    return {
      id: this.id,
      grades: this.grades.map(g => ({
        id: g.id,
        foreign_hotel_price_limit: g.foreignHotelPriceLimit
      })),
      countries: this.countries.map(c => ({
        id: c.id,
        grades: c.grades.map(g => ({
          id: g.id,
          foreign_hotel_price_limit: g.foreignHotelPriceLimit
        }))
      }))
    };
  }

  setForeignHotelPriceLimit(value: number, g_id: number | null, c_id: number) {
    if (c_id === 0) {
      this.grades.filter(g => g.id === g_id)[0].foreignHotelPriceLimit = value;
    } else {
      this.countries.filter(c => c.id === c_id)[0].grades.filter(g => g.id === g_id)[0].foreignHotelPriceLimit =
        value;
    }
    app.render();
  }

  toggleRegionDisabled() {
    this.hidden = !this.hidden;
    app.render();
  }

  toggleCountryDisabled() {
    this.countries.forEach(c => {
      c.hidden = !c.hidden;
    });
    app.render();
  }
}

export default ForeignRegion;
